import React, { useRef } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"

type ScrollerProps = {
	children: React.ReactNode
	elementWidth: number
}

export default function Scroller({ children, elementWidth }: ScrollerProps) {
	const cardWidth = elementWidth - 50
	const containerRef = useRef<HTMLDivElement>(null)

	const scroll = (amount: number) => {
		if (containerRef.current) {
			containerRef.current.scrollLeft += amount
		}
	}

	return (
		<div className="flex flex-col md:gap-12 gap-4 md:gap-8 items-end">
			<div
				ref={containerRef}
				className="flex lg:gap-12 gap-3 md:gap-6 overflow-x-scroll w-full scroll-smooth snap-x snap-mandatory pb-2 [&::-webkit-scrollbar]:hidden"
			>
				{React.Children.map(children, (child, index) => (
					<div key={index} className="snap-start">
						{child}
					</div>
				))}
			</div>
			<div className="flex justify-between items-center">
				<div className="flex gap-3 md:gap-6">
					<button
						onClick={() => scroll(-cardWidth)}
						className="bg-transparent hover:bg-white hover:text-dark transition-colors ease-in-out duration-200 border-white text-white border-2 lg:text-xl text-lg flex items-center justify-center lg:px-6 lg:py-6 px-3 py-3 md:px-4 md:py-4"
					>
						<ChevronLeft className="md:w-6 md:h-6 w-4 h-4" />
					</button>
					<button
						onClick={() => scroll(cardWidth)}
						className="bg-transparent hover:bg-white hover:text-dark transition-colors ease-in-out duration-200 border-white text-white border-2 lg:text-xl text-lg flex items-center justify-center lg:px-6 lg:py-6 px-3 py-3 md:px-4 md:py-4"
					>
						<ChevronRight className="md:w-6 md:h-6 w-4 h-4" />
					</button>
				</div>
			</div>
		</div>
	)
}
